import { Reducer } from 'react';

import { IUser } from '@model';

export type TUserState = IUser;

export enum EUserAction {
  SET_USER,
  SET_USER_EMAIL,
}

type TSetUserAction = IUser;

interface ISetUserEmail {
  email: string;
}

export type TUserActions =
  | { action: EUserAction.SET_USER; payload: TSetUserAction }
  | { action: EUserAction.SET_USER_EMAIL; payload: ISetUserEmail };

export interface IUserActions {
  loadUser: () => Promise<void>;
  setUserEmail: (email: string) => void;
}

export type TUserReducer = Reducer<TUserState, TUserActions>;
